import { Body } from "app/_components/components/Text/Body";
import { Heading } from "app/_components/components/Text/Heading";
import { Card } from "app/_components/components/Card";
import { Button } from "app/_components/components/Button";
import Link from "next/link";
import type { Locale } from "i18n/constants";
import { getT } from "i18n/utils";
import React from "react";
import { getLocale } from "i18n/server";

const StoreCard = async ({
  coinName,
  coinSymbol
}: {
  coinName: string;
  coinSymbol: string;
}) => {
  const locale = await getLocale();
  const t = await getT(locale as Locale, "/prices/[...coin]");

  return (
    <Card padding="md" className="mb-3">
      <Heading size="md">{t("prices.storeButton", { coinName })}</Heading>
      <Body size="sm" className="mt-1">
        {t("prices.delistedTokenMessage", { coinSymbol })}
      </Body>
      <Button asChild variant="primary" size="lg" className="mt-3 w-full">
        <Link href="https://exchange.gemini.com/register">
          {t("prices.getStarted")}
        </Link>
      </Button>
    </Card>
  );
};

export default StoreCard;
